
var initialState = {
  isOpen: false,
  hasError: null
};

// instead of isMarkingComplete
// generalise with isPending
export default function modal(state = initialState, action) {
    var stayOpenOnBodyClickArray = ["ScheduleModal", "CreateContactsModal"];

    switch (action.type) {
        case 'OPEN_MODAL':
            var modalName = action.modalType.WrappedComponent ? action.modalType.WrappedComponent.name : action.modalType.name;
            var stayOpenOnBodyClick = stayOpenOnBodyClickArray.includes(modalName);
            return {
                ...state,
                isOpen: true,
                type: action.modalType,
                props: action.props,
                stayOpenOnBodyClick
            };
        case 'CLOSE_MODAL':
            return {
                ...state,
                isOpen: false,
                hasError: null
            };
        case 'DELETE_NOTE':
            return {
                ...state,
                isDeletingNote: true
            };
        case 'DELETE_NOTE_SUCCESS':
            return {
                ...state,
                isDeletingNote: false,
                isOpen: false
            };
        case 'CREATE_CONTACT':
            return {
                ...state,
                isSavingContact: true
            };
        case 'CREATE_CONTACT_SUCCESS':
            return {
                ...state,
                isSavingContact: false,
                isOpen: false
            };
        case 'CREATE_SCHEDULE':
            return {
                ...state,
                isSavingSchedule: true
            };
        case 'CREATE_SCHEDULE_SUCCESS':
            return {
                ...state,
                isSavingSchedule: false,
                isOpen: false
            };
        case 'RECORD_PHONE_CALL_COMPLETE':
            return {
                ...state,
                isMarkingComplete: true
            };
        case 'RECORD_PHONE_CALL_COMPLETE_SUCCESS':
            return {
                ...state,
                isMarkingComplete: false,
                isOpen: false
            };
        case 'UPDATE_SCHEDULE':
            return {
                ...state,
                isSavingSchedule: true
            };
        case 'UPDATE_SCHEDULE_SUCCESS':
            return {
                ...state,
                isSavingSchedule: false,
                isOpen: false
            };
        case 'DELETE_SCHEDULE':
            return {
                ...state,
                isDeletingSchedule: true
            };
        case 'DELETE_SCHEDULE_SUCCESS':
            return {
                ...state,
                isDeletingSchedule: false,
                isOpen: false
            };
        case 'MARK_SCHEDULE_COMPLETE':
            return {
                ...state,
                isMarkingComplete: true
            };
        case 'SCHEDULE_MARKED_COMPLETE_SUCCESS':
            return {
                ...state,
                isMarkingComplete: false,
                isOpen: false
            };
        case 'SET_TRIAL_EXPIRY':
            return {
                ...state,
                isSavingTrialPeriod: true,
            };
        case 'SET_TRIAL_EXPIRY_SUCCESS':
            return {
                ...state,
                isSavingTrialPeriod: false,
                isOpen : false,
            };
        case 'SET_TRIAL_EXPIRY_FAIL':
            return {
                ...state,
                isSavingTrialPeriod: false,
            };
        case 'CHANGE_TO_TRIAL':
            return {
                ...state,
                isSavingChangeToTrial: true,
            };
        case 'CHANGE_TO_TRIAL_SUCCESS':
            return {
                ...state,
                isSavingChangeToTrial: false,
                isOpen : false,
            };
        case 'CHANGE_TO_TRIAL_FAIL':
            return {
                ...state,
                isSavingChangeToTrial: false,
            };
        case 'UPDATE_CONTACT':
            return {
                ...state,
                isSavingContact: true
            };
        case 'UPDATE_CONTACT_SUCCESS':
            return {
                ...state,
                isSavingContact: false,
                isOpen: false
            };
        case 'CREATE_NOTE':
            return {
                ...state,
                isSavingNote: true
            };
        case 'CREATE_NOTE_SUCCESS':
            return {
                ...state,
                isSavingNote: false,
                isOpen: false
            };
        case 'UPDATE_NOTE':
            return {
                ...state,
                isSavingNote: true
            };
        case 'UPDATE_NOTE_SUCCESS':
            return {
                ...state,
                isSavingNote: false,
                isOpen: false
            };
        case 'UPDATE_USERS_ASSIGNED_TO_CLIENT':
            return {
                ...state,
                isAssigningUserToClient: true
            };
        case 'UNMARK_AS_DUD_SUCCESS': {
            return {
                ...state,
                isOpen: false
            };
        }
        case 'QUALIFY_CLIENT_SUCCESS': {
            return {
                ...state,
                isOpen: false,
                isSavingQualify : false
            }
        }
        case 'QUALIFY_CLIENT_FAIL': {
            return {
                ...state,
                isSavingQualify : false
            }
        }        
        case 'QUALIFY_CLIENT': {
            return {
                ...state,
                isSavingQualify : true
            }
        }
        case 'FREE_PLAN_TYPE_CLIENT_SUCCESS': {
            return {
                ...state,
                isOpen: false
            }
        }
        case 'MIGRATE_BILLING_REGION_SUCCESS': {
            return {
                ...state,
                isOpen: false,
                errorMigratingBillingRegion: false,
                isUpdatingBillingRegion : false
            }
        }
        case 'MIGRATE_BILLING_REGION': {
            return {
                ...state,
                errorMigratingBillingRegion: null,
                isUpdatingBillingRegion : true
            }
        }
        case 'MIGRATE_BILLING_REGION_FAIL': {
            return {
                ...state,
                errorMigratingBillingRegion: true,
                isUpdatingBillingRegion : false
            }
        }
        case 'DISABLE_EMPLOYEE_SUCCESS': {
            return {
                ...state,
                hasError: false,
                isDisablingEmployee : false,
                isOpen: false
            }
        }
        case 'DISABLE_EMPLOYEE': {
            return {
                ...state,
                hasError: null,
                isDisablingEmployee : true
            }
        }
        case 'DISABLE_EMPLOYEE_FAIL': {
            return {
                ...state,
                hasError: true,
                isDisablingEmployee : false
            }
        }
        case 'REENABLE_EMPLOYEE_SUCCESS': {
            return {
                ...state,
                hasError: false,
                isReenablingEmployee : false,
                isOpen: false
            }
        }
        case 'REENABLE_EMPLOYEE': {
            return {
                ...state,
                hasError: null,
                isReenablingEmployee : true
            }
        }
        case 'REENABLE_EMPLOYEE_FAIL': {
            return {
                ...state,
                hasError: true,
                isReenablingEmployee : false
            }
        }
        case 'UPDATE_LOCK_STATUS_SUCCESS': {
            return {
                ...state,
                isOpen: false,
                errorUpdatingLockStatus: false,
                isUpdatingLockStatus : false
            }
        }
        case 'UPDATE_LOCK_STATUS': {
            return {
                ...state,
                errorUpdatingLockStatus: null,
                isUpdatingLockStatus : true
            }
        }
        case 'UPDATE_LOCK_STATUS_FAIL': {
            return {
                ...state,
                errorUpdatingLockStatus: true,
                isUpdatingLockStatus : false
            }
        }

        case 'UPDATE_DISCOUNT_SUCCESS': {
            return {
                ...state,
                isOpen: false,
                errorUpdatingDiscount: false,
                isUpdatingDiscount : false
            }
        }
        case 'UPDATE_DISCOUNT': {
            return {
                ...state,
                errorUpdatingDiscount: null,
                isUpdatingDiscount : true
            }
        }
        case 'UPDATE_DISCOUNT_FAIL': {
            return {
                ...state,
                errorUpdatingDiscount: true,
                isUpdatingDiscount : false
            }
        }

        case 'CREATE_CREDIT_ITEM':
            return {
                ...state,
                isSavingCreditHistory: true
            }
        case 'CREATE_CREDIT_ITEM_SUCCESS':
            return {
                ...state,
                isOpen: false,
                isSavingCreditHistory: false
            }
        case 'CREATE_CREDIT_ITEM_FAIL':
            return {
                ...state,
                isSavingCreditHistory: false
            }
        case 'CHANGE_MIDDYS_STATUS':
            return {
                ...state,
                isSaving: true
            };
        case 'CHANGE_MIDDYS_STATUS_SUCCESS':
            return {
                ...state,
                isSaving: false,
                isOpen: false
            };
        case 'UPDATE_USERS_ASSIGNED_TO_CLIENT_SUCCESS':
            return {
                ...state,
                isAssigningUserToClient: false,
                isOpen: false
            };
        case 'MARK_AS_DUD':
            return {
                ...state,                
                markingAsDud : true
            };
        case 'MARK_AS_DUD_FAIL':
            return {
                ...state, 
                markingAsDud : false
            };
        case 'MARK_AS_DUD_SUCCESS':
            return {
                ...state,
                markingAsDud : false,
                isOpen: false
            };
        case 'DELETE_CONTACT':
            return {
                ...state,
                isSaving : true
            };
        case 'DELETE_CONTACT_SUCCESS':
            return {
                ...state,
                isSaving : false,
                isOpen: false
            };
        case 'UPDATE_CLIENT_STAGE':
            return {
                ...state,
                isSaving : true
            };
        case 'UPDATE_CLIENT_STAGE_SUCCESS':
            return {
                ...state,
                isSaving : false,
                isOpen: false
            };
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./app/reducers/modal.js